import React from "react";
import styled from "@emotion/styled";
import { Tutorials } from "components/Tutorials";
import member_matching from "assets/images/video_covers/member_matching.jpg";
import { CLOUDFRONT_URL } from "constants/index";
import { breakpoints, gradients } from "style";
import Card from "components/Card";

/**
 * TutorialMissions
 */
const TutorialMissions = (props) => (
  <TutorialCard fixedHeight>
    <Tutorials
      keyName={TUTORIAL_MISSIONS_KEYNAME}
      videoList={[
        {
          name: "Welcome",
          cover: member_matching,
          source: `${CLOUDFRONT_URL}videos/explainers/explainer_mission_board.mov`,
          duration: "0:56",
        },
      ]}
      text={{
        bodyTitle: "Missions.MissionsTutorial.Title",
        bodyDescription: "Missions.MissionsTutorial.Description",
      }}
      isCloseable={false}
      hideOnClose
      isFooterCloseable
      {...props}
    />
  </TutorialCard>
);

const TutorialCard = styled(Card)`
  padding: 0;
  background: ${gradients.sideBarGradient};
  color: #fff;
  border: 0;

  @media (min-width: ${breakpoints.wide}) {
    flex-direction: row;

    #tutorial-card {
      width: 150%;

      #tutorial-video {
        border-top-left-radius: 1rem;
        border-bottom-left-radius: 1rem;
      }
    }

    #tutorial-footer {
      padding: 0;
      margin: 3rem;

      #tutorial-footer-description {
        font-size: 1.5rem;
        line-height: 1.3;
      }
    }
  }
`;

const TUTORIAL_MISSIONS_KEYNAME = `mission_board_tour_visible`;

export { TUTORIAL_MISSIONS_KEYNAME };

export default TutorialMissions;
